import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { IconButton, Stack, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { GridColDef } from '@mui/x-data-grid';
import { withImeStringFilter } from 'src/components/dataGrid/imeStringFilter';
import { DriverEntity } from 'src/entities/driverEntity';
import { dataGridUtil } from 'src/utils/dataGrid.util';

export const Columns: (
  openEditDialog?: (truckEntity: DriverEntity) => void
) => GridColDef[] = (
  openEditDialog
) => {
  const getWidth = (name: string, width: number) => {
    const maybeWidth: number = dataGridUtil.getSavedColumnWidth('driver-columns', name);

    return maybeWidth || width;
  };

  // renderCell が openEditDialog を無条件に呼ぶため、未指定のまま列を出すと押下で crash する。
  // 選択ダイアログなど編集不要の呼び出し元があるので、列自体を出さない。
  const editColumn: GridColDef | null = openEditDialog ? {
    field: 'edit',
    headerName: '編集',
    disableExport: true,
    renderCell: (params: { row: DriverEntity }) => (
      <IconButton onClick={() => openEditDialog(params.row)}>
        <EditOutlinedIcon />
      </IconButton>
    ),
    filterable: false,
    sortable: false,
  } : null;

  // 型注釈は必須。.filter() を挟むと配列リテラルの文脈型が外れ、type: 'number' や
  // display: 'flex' が string に広がって GridColDef の判別ユニオンに合わなくなる。
  const columns: GridColDef[] = [
    editColumn,
    {
      field: 'company_name',
      headerName: '事業所',
      width: getWidth('company_name', 300),
    },
    {
      field: 'name',
      headerName: '名前',
      width: getWidth('name', 280),
      renderCell: (params: { row: DriverEntity }) => (
        <Stack direction="row" sx={{ height: '100%' }} alignItems="center">
          <Stack
            borderLeft={20}
            borderColor={params.row.color}
            spacing={0.5}
            marginRight={0.5}
          >
            &nbsp;
          </Stack>
          <Typography>
            {params.row.name}
          </Typography>
        </Stack>
      )
    },
    {
      field: 'driver_cost_yen_per_hours',
      headerName: '時給',
      width: getWidth('driver_cost_yen_per_hours', 70),
      type: 'number',
    },
    {
      field: 'phone_number',
      headerName: '電話番号',
      width: getWidth('phone_number', 170)
    },
    {
      field: 'email_address',
      headerName: 'メールアドレス',
      width: getWidth('email_address', 400),
      // x-data-grid v8 ではセルが既定で display: block のため、renderCell が返す
      // アイコン + Typography が縦に積み重なって表示が崩れる。display: 'flex' を
      // 指定してセルを横並び・縦中央揃えの flex コンテナにする。
      display: 'flex',
      renderCell: (params: { row: DriverEntity }) => {
        // email_address?: string は undefined も取り得るため null/'' だけでなく
        // undefined も弾く。さもないと未設定でも CloseIcon だけ描画される。
        if (!params.row.email_address) return '';

        let activationState = <CloseIcon sx={{ color: red[500] }} />;
        if (params.row.activation_state === 'active') {
          activationState = <DoneIcon color="success" />;
        }

        return (
          <>
            {activationState}
            <Typography variant="body1" paddingLeft={1}>
              {params.row.email_address}
            </Typography>
          </>
        );
      }
    },
  ];

  return withImeStringFilter(columns.filter((maybe) => !!maybe));
};
